import React, { useState, useEffect } from "react";
import { getIconByName, getName } from "../report-service/report-menu-service";
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import s from "./create-component.module.scss";
import { StandartButton } from "commons/form-controls";

const CreateComponent = (props) => {

    const [elements, setElements] = useState(props.reportComponents ? Object.keys(props.reportComponents) : []);
    const [parameters, setParameters] = useState(props.parameters);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly);
    
    useEffect(() => {
        setElements(props.reportComponents ? Object.keys(props.reportComponents) : []);
        setParameters(props.parameters);
        setIsReadOnly(props.isReadOnly);
    }, [props]);

    const addComponent = (name) => {
        props.addNewComponents(name)
    }

    const getFinded = (type) => {
        let params = Object.values(parameters);
        let findedIndex = 0;
        params.forEach(k => {if(k.type == type) findedIndex += 1});

        return findedIndex;
    }

    const reportComponents = elements.map((k, i) => <button key={i} disabled={isReadOnly} className={s.menuItem} onClick={addComponent.bind(this, k)}><span>{getName(k)}</span><div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>{getIconByName(k)}<span>{getFinded(k) > 0 ? getFinded(k) : ''}</span></div></button>);

    return (
        <div className={s.CreateComponent}>
            {/*<div className={s.CreateHeader}>
                
                <StandartButton icon={CloseIcon} background={'var( --background )'}/>
            </div>*/}
            <div className={s.CreateBody}>
                { reportComponents }
            </div>
        </div>
    )
}

export default CreateComponent;